import React from "react";
import styles from "./styles";
import { Button, IconButton, Paper, withStyles, withTheme } from "@material-ui/core";
import {
  ArrowBack,
  ExpandLess,
  Close,
  LowPriority,
  AddBoxOutlined,
} from "@material-ui/icons";
import Details from "./Details";
import Cards from "./Cards";
import { observer, inject } from "mobx-react";
import { DRIVER_EVENTS, SHOW_DRIVER_LOGGED_STATUS } from "../constants";
import {
  completedVsTotalStopsFormatter,
  getTotalDeliveryStops,
  sortStopsBySequence,
} from "../../utils/utils";
import Events from "../../../../../utilities/EventEmitter";
import RefreshWarningBar from "../RefreshWarningBar";
import appConstants from "../../../../../appConstants";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import StyledToolTip from "../../../../common/StyledToolTip";
import ResequenceHelperText from "./ResequenceHelperText";
import { postData } from "../../../../../api/componentAPIs";
import Dialog from "../../../../common/Dialog";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import {
  isStopLocked,
  isStopLockedPermanently,
  getRoutePlacards,
  getProNumbers,
} from "./utils";
import isEqual from "lodash.isequal";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";
import { trackEvent } from "../../../../common/AppInsightsEventTracking";
import HazmatPlacards from "./HazmatPlacard";
import AddProDialog from "./AddProDialog/index";
import StopMoveFeedbackPanel from "../../../IBPlanning/RoutesView/StopMoveFeedbackPanel";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import DropHookMoveModal from "../TrailerDropAndHook/DropHookMoveModal/index";
import LocalShippingOutlinedIcon from "../utils/DriverStatus/Icons/LocalShippingOutlinedIcon";
import StopImagesDialog from "./StopImagesDialog"
import { STOP_IMAGES } from "./StopImagesDialog/getBlobImages";
import TerminalCard from "./TerminalStopCard";
import { withAppConfig } from "../../../../../appConfigContext";

@inject("DispatchStore")
@observer
class DriverPopup extends React.Component {
  constructor(props) {
    super(props);
    this.cardContainerRef = React.createRef();
    this.state = {
      isExpanded: this.props.defaultExpanded || false,
      routeData: this.props.routeData,
      currentDriverRoutes: this.getCurrentDriverRoutes(
        this.props.routeData.driverId
      ),
      resequencingInProgress: false,
      showResequenceHelperText: false,
      showPendingChangesWarning: false,
      showConfirmation: false,
      stopsWithoutDelays: null,
      isAddProInProgress: false,
      isOpenDropHookMoveModal: false,
      viewStopImages: null
    };
    this.feedbackPanelKey = null;
    this.portalItem = null;
    this.isResequenceSuccess = false; // If resequence request is complete, update data in component did update
    this.enableDispatchRouteResequence = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableDispatchRouteResequence
    );
    this.enableAddPro = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableAddPro
    );
    this.enableRemovePro = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableRemovePro
    );
    this.enableDropHookMove = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableDropHookMove
    );
  }

  componentDidMount() {
    Events.on("NextStopChanged", this.checkMakeNextStopEvent);
    if (!this._ismounted && this.state.isExpanded) {
      this.scrollToIncompleteStop();
    }
    this._ismounted = true;
    if (!this.portalItem) {
      this.portalItem = document.createElement("div");
      this.portalItem.id = "drag";
    }
    document.body.appendChild(this.portalItem);
    Events.on("stopMoved", this.stopMoveCompleted);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isExpanded && this.state.isExpanded) {
      this.scrollToIncompleteStop();
    }
    if (
      prevProps.routeData.driverId !== this.props.routeData.driverId ||
      prevProps.routeData.routeId !== this.props.routeData.routeId
    ) {
      if (this.isStopListUpdated()) {
        this.setState({
          showPendingChangesWarning: true,
        });
      } else {
        this.refreshDriverInfo();
      }
    } else if (
      !this.state.resequencingInProgress &&
      this.state.routeData.routeId === this.props.routeData.routeId &&
      !isEqual(this.state.routeData, this.props.routeData)
    ) {
      // When not in resequencing mode show updated driver status
      this.setState({
        routeData: this.props.routeData,
        currentDriverRoutes: this.getCurrentDriverRoutes(
          this.props.routeData.driverId
        ),
      });
    }
    if (this.isResequenceSuccess) {
      this.refreshDriverInfo();
    }
  }


  closeDropHookMoveModal = () => {
    this.setState({ isOpenDropHookMoveModal: false });
  };

  getUpdatedStopSequence = (routeData) => {
    const { currentStatus } = routeData;

    const arrivedStopId =
      currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop
        ? currentStatus?.stopId
        : null;
    return sortStopsBySequence(routeData.stops).find(
      (stop) => !stop.isStopCompleted && stop.stopId !== arrivedStopId
    )?.stopSequence || "";
  };

  checkMakeNextStopEvent = ({ success, kpi }) => {
    const { markedAsNextStopData } = this.state;
    const { routeData } = this.props;
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (success) {
      this.feedbackPanelKey = this.props.enqueueSnackbar("Next Stop Changed", {
        content: (
          <StopMoveFeedbackPanel
            moveType={appConstants.STOP_MOVES.MARK_NEXT_STOP}
            hideUndo
            hideCostKpi
            data={{
              totalTime: kpi?.estimatedTravelTimeDifference,
              totalMiles: kpi?.estimatedMilesDifference,
              numServiceViolations: kpi?.numServiceViolations,
              nextStopMarkedData: markedAsNextStopData,
              updatedStopData: {
                stopSequence: this.getUpdatedStopSequence(routeData),
                stopType: markedAsNextStopData.stopType,
              },
            }}
            onClose={this.onCloseFeedbackPanel}
          />
        ),
        autoHideDuration: 30000,
        style: { pointerEvents: "none" },
      });
    } else {
      this.props.enqueueSnackbar(`Next Stop change failed`, {
        variant: "error",
      });
    }
  };

  onNextStopChangeFailed = () => {
    this.props.enqueueSnackbar(`Next Stop change failed`, {
      variant: "error",
    });
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
  };

  updateNextStop = (markedAsNextStopData) => {
    const { routeData, userData } = this.props;
    const requestParams = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      routeId: routeData.routeId,
      stopId: markedAsNextStopData.stopId,
    };
    trackEvent("Mark_As_Next_Stop", this.props.userData.userProfile, {
      eventData: requestParams,
    });
    this.setState({
      markedAsNextStopData,
    });
    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      "Stop resequencing",
    ]);
    postData("MarkAsNextStop", requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) !== 2) {
          this.onNextStopChangeFailed();
        }
      },
      () => {
        this.onNextStopChangeFailed();
      }
    );
  };

  onCloseFeedbackPanel = () => {
    if (this.feedbackPanelKey !== null) {
      this.props.closeSnackbar(this.feedbackPanelKey);
      this.feedbackPanelKey = null;
    }
  };

  getCurrentDriverRoutes = (driverId) => {
    return this.props.DispatchStore.routesList.filter(
      (route) => route.driverId === driverId
    );
  };

  componentWillUnmount() {
    Events.off("NextStopChanged", this.checkMakeNextStopEvent);
    this._ismounted = false;
    if (this.portalItem) {
      this.portalItem.parentNode?.removeChild(this.portalItem);
      this.portalItem = null;
    }
    Events.removeListener("stopMoved", this.stopMoveCompleted);
  }

  scrollToIncompleteStop = () => {
    const { routeData } = this.props;
    const firstIncompleteStopIndex = sortStopsBySequence(
      routeData.stops
    ).findIndex((stop) => !stop.isStopCompleted);
    const scrollValue = this.getScrollToHeightValue(firstIncompleteStopIndex);
    setTimeout(() => {
      this.handleScrollTo(scrollValue);
    }, 100);
  };

  refreshDriverInfo = () => {
    this.setState({
      routeData: this.props.routeData,
      currentDriverRoutes: this.getCurrentDriverRoutes(
        this.props.routeData.driverId
      ),
      resequencingInProgress: false,
      showResequenceHelperText: false,
      showPendingChangesWarning: false,
      showConfirmation: false,
      stopsWithoutDelays: null,
    });
    this.isResequenceSuccess = false;
  };

  stopMoveCompleted = (data) => {
    const { isEventProcessed } = JSON.parse(data);
    this.isResequenceSuccess = isEventProcessed;
  };

  getCompletedStopCardHeight = () => {
    return (
      this.cardContainerRef?.current?.childNodes[0]?.childNodes[0]
        ?.offsetHeight + 4
    );
  };

  getScrollToHeightValue = (firstIncompleteStopIndex = 0) => {
    return firstIncompleteStopIndex * this.getCompletedStopCardHeight();
  };

  handleScrollTo = (scrollValue) => {
    this.cardContainerRef.current?.scroll({
      top: scrollValue,
      behavior: "smooth",
    });
  };

  toggleExpand = () => {
    this.setState((state) => ({
      isExpanded: !state.isExpanded,
    }));
  };

  getDriverEnrouteOrArrivedAtStopId = () => {
    const { routeData } = this.state;
    if (
      routeData?.currentStatus &&
      [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
        routeData.currentStatus.status
      )
    ) {
      return routeData.currentStatus?.stopId;
    }
    return null;
  };

  isDriverCurrentStop = (stopId) => {
    return this.getDriverEnrouteOrArrivedAtStopId() === stopId;
  };

  isDriverLoggedIn = () => {
    const { routeData } = this.state;
    return (
      SHOW_DRIVER_LOGGED_STATUS[routeData.loggedInStatus] ===
      SHOW_DRIVER_LOGGED_STATUS.loggedIn
    );
  };

  refreshStopList = () => {
    Events.emit(
      appConstants.DISHPATCH_EVENTS.UPDATE_DISPATCH_DRIVER_ROUTES,
      this.props.routeData.driverId
    );
  };

  enableResequencing = () => {
    if (!this.state.resequencingInProgress) {
      this.setState({
        resequencingInProgress: true,
        showResequenceHelperText: true,
        stopsWithoutDelays: sortStopsBySequence(this.props.routeData.stops),
      });
    }
  };

  cancelResequence = () => {
    this.refreshDriverInfo();
  };

  saveResequence = () => {
    const requestData = {
      driverId: this.state.routeData.driverId,
      routeId: this.state.routeData.routeId,
      userId: this.props.userProfile.userId,
      terminalCode: this.props.userProfile.terminal.code,
      stops: this.state.stopsWithoutDelays
        .filter((stop) => stop.isLocked && !stop.isStopCompleted)
        .map((stop, index) => {
          return {
            stopId: stop.stopId,
            sequence: index + 1, // Start sequence from 1,2,3
            isLocked: Boolean(stop.isLocked),
          };
        }),
      eventDateTime: new Date(),
    };

    trackEvent("StopMoveByDispatcher", this.props.userProfile, {
      manifest: this.state.routeData.manifestNumber,
      userId: this.props.userProfile.userId,
      routeId: this.state.routeData.routeId,
      lockedStopIds: requestData.stops.map((stop) => stop.stopId),
      eventDateTime: requestData.eventDateTime,
    });

    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      {
        label: "Stop resequencing",
        eventName: "Stop Resequence",
        pickupIds: [],
      },
    ]);
    postData("saveDispatchRouteStopResequence", requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onSaveDispatchStopSequenceFailed();
        }
      })
      .catch((error) => {
        this.onSaveDispatchStopSequenceFailed();
      });
  };

  refreshStopList = () => {
    Events.emit(
      appConstants.DISPATCH_EVENTS.UPDATE_DISPATCH_DRIVER_ROUTES,
      this.state.routeData.driverId
    );
  };

  changeRouteData = (routeId) => {
    const selectedDriverRoute = this.state.currentDriverRoutes.find(
      (route) => route.routeId === routeId.value
    );
    const newSelectedRoutes =
      this.props.DispatchStore.selectedRouteNameList.map((route) =>
        route === this.state.routeData.routeId ? routeId.value : route
      );
    if (selectedDriverRoute) {
      selectedDriverRoute.color = this.state.routeData.color;
      this.setState({ routeData: selectedDriverRoute });
      this.props.DispatchStore.updateSelectedDriverRouteId(
        selectedDriverRoute.routeId
      );
      this.props.glEventHub.emit(
        "UpdateDispatchStore",
        "updateSelectedRoutes",
        [newSelectedRoutes]
      );
    }
  };

  onSaveDispatchStopSequenceFailed = () => {
    this.props.enqueueSnackbar(
      `Failed to update stop sequence for driver ${this.state.routeData.driverName}, route ${this.state.routeData.routeName}`,
      { variant: "error" }
    );
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
  };

  onLockChanged = (stopSequence, isLocked) => {
    if (isLocked) {
      // If Locking a stop lock all the stops in sequence before the stops
      this.setState((state) => ({
        stopsWithoutDelays: state.stopsWithoutDelays.map((stop) => {
          if (stop.stopSequence <= stopSequence) {
            return {
              ...stop,
              isLocked,
            };
          }
          return stop;
        }),
      }));
    } else {
      // If unlocked stop is completed skip unlocking
      const isStopCompleted = this.state.stopsWithoutDelays.find(
        (stop) => stop.stopSequence === stopSequence
      )?.isStopCompleted;
      if (isStopCompleted) {
        return;
      }
      // Unlocking a non completing stop should unlock all stops after selected stop
      this.setState((state) => ({
        stopsWithoutDelays: state.stopsWithoutDelays.map((stop) => {
          if (stop.stopSequence >= stopSequence) {
            return {
              ...stop,
              isLocked,
            };
          }
          return stop;
        }),
      }));
    }
  };

  showConfirmationModal = () => {
    this.setState({
      showConfirmation: true,
    });
  };

  onCloseConfirmation = (confirmed) => {
    if (confirmed) {
      this.saveResequence();
    }
    this.setState({
      showConfirmation: false,
    });
  };

  hideResequenceHelperText = () => {
    this.setState({
      showResequenceHelperText: false,
    });
  };

  isDragDisabled = (stop) => {
    return (
      !this.state.resequencingInProgress ||
      isStopLocked(stop, this.state.routeData.currentStatus)
    );
  };

  onClosePendingChangesWarning = (confirmed) => {
    if (confirmed) {
      this.saveResequence();
      setTimeout(() => {
        this.refreshDriverInfo();
      }, 10000);
    } else {
      this.refreshDriverInfo();
    }
    this.setState({
      showPendingChangesWarning: false,
    });
  };

  // Drag & drop  methods

  onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) {
      // dropped outside droppable area
      return;
    }

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      // no change in position
      return;
    }

    let destinationIndex = destination.index;
    const firstDraggableIndex =
      this.state.stopsWithoutDelays.find((stop) => !this.isDragDisabled(stop))
        ?.stopSequence || 0;
    // If dragged a stop to locked stop area, move it to the first unlocked stop sequence
    if (destination.index < firstDraggableIndex) {
      destinationIndex = firstDraggableIndex - 1;
    }

    const newStopsWithoutDelays = Array.from(this.state.stopsWithoutDelays);
    const deletedElement = newStopsWithoutDelays.splice(source.index, 1);
    newStopsWithoutDelays.splice(destinationIndex, 0, deletedElement[0]);
    this.setState({
      stopsWithoutDelays: newStopsWithoutDelays.map((stop, index) => {
        return {
          ...stop,
          stopSequence: index + 1,
        };
      }),
    });
  };

  isStopListUpdated = () => {
    // Check if user modifiyable stops were updated i.e lockStatus update or sequence update
    if (!this.state.stopsWithoutDelays) {
      return false;
    }
    const initialStops = sortStopsBySequence(
      this.state.routeData.stops
    ).filter(
      (stop) =>
        !isStopLockedPermanently(stop, this.state.routeData.currentStatus)
    );
    const updatedStops = this.state.stopsWithoutDelays.filter(
      (stop) =>
        !isStopLockedPermanently(stop, this.state.routeData.currentStatus)
    );

    const stops = updatedStops.find((stop, index) => {
      const initialStop = initialStops[index];
      return (
        stop.stopSequence === initialStop.stopSequence &&
        (stop.isLocked !== initialStop.isLocked ||
          stop.stopId !== initialStop.stopId)
      );
    });
    return Boolean(stops);
  };

  getDraggableItemStyle = (draggableStyle, lockPosition) => {
    const transformPosition = lockPosition ? { transform: "0px" } : {}; // disabled moving of locked columns when a column is dragged over them
    return {
      ...draggableStyle,
      ...transformPosition,
    };
  };

  // Creates a draggable item
  getDraggableItem = (provided, snapshot, stop) => {
    const draggableItem = (
      <div
        key={`driver_stop_cards_container${stop.stopId}`}
        id={stop.stopId}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={this.getDraggableItemStyle(
          provided.draggableProps.style,
          this.isDragDisabled(stop)
        )}
      >
        <Cards
          key={`driver_stop_cards_${stop.stopId}`}
          stopData={stop}
          driverId={this.state.routeData.driverId}
          routeData={this.state.routeData}
          enableDispatchRouteResequence={this.enableDispatchRouteResequence}
          glEventHub={this.props.glEventHub}
          defaultExpanded={!stop.isStopCompleted}
          resequenceMode={this.state.resequencingInProgress}
          isDriverCurrentStop={this.isDriverCurrentStop(stop.stopId)}
          onLockChanged={this.onLockChanged}
          updateNextStop={this.updateNextStop}
          enableRemovePro={this.enableRemovePro}
          enableAddNotesToPro={this.props.configJSON.enableAddNotesToPro}
          enableAddProToCompletedPro={this.props.configJSON.enableAddProToCompletedPro}
          viewStopImages={() => this.onViewStopImages(stop)}
          theme={this.props.theme}
          terminalCode= {this.props.userProfile.terminal.code}
        />
      </div>
    );
    if (snapshot.isDragging) {
      return ReactDOM.createPortal(draggableItem, this.portalItem); // Renders dragged item above all the elements inside body
    }
    return draggableItem;
  };

  handleAddPro = () => {
    this.setState({
      isAddProInProgress: true,
    });
  };

  cancelAddPro = () => {
    this.setState({
      isAddProInProgress: false,
    });
  };

  getRouteInfoMinHeight = (routesCount, placardsCount) => {
    // using this function set min height since not able to handle this using flex. Need to do more research
    let minHeight = 120;
    minHeight += routesCount > 1 ? 40 : 0;
    minHeight += placardsCount > 0 ? 70 : 0;
    return minHeight;
  };

  handleDropAndHookMenuOpen = () => {
    this.setState({
      isOpenDropHookMoveModal: true,
    });
  };
  onViewStopImages = (stop) => {
    this.setState({
      viewStopImages: {
        terminalCode: this.props.userProfile.terminal.code,
        routeId: this.state.routeData.routeId,
        stopId: stop.stopId,
        isStopCompleted: stop.isStopCompleted,
        proNumbers: getProNumbers(stop.shipments),
      },
    });
  }

  onHideStopImages = () => {
    this.setState({
      viewStopImages: null
    })
  }

  render() {
    const { classes, theme} = this.props;
    const {
      routeData,
      isExpanded,
      resequencingInProgress,
      showPendingChangesWarning,
      showResequenceHelperText,
      showConfirmation,
    } = this.state;
    const totalPickups = routeData.totalPickups || 0;
    const totalDeliveries = getTotalDeliveryStops(routeData.stops);
    const isStopListUpdated =
      resequencingInProgress && this.isStopListUpdated();
    const footerDetails = `${totalDeliveries} Deliveries | ${totalPickups} Pickups `;
    const stopsWithoutDelays =
      this.state.stopsWithoutDelays ?? sortStopsBySequence(routeData.stops);
    const latestLunchBreak =
      this.props.DispatchStore.populateLatestLunchBreakTime(routeData.delays);
    if (!isExpanded) {
      return (
        <Paper
          className={`${classes.outerMostWrapper} ${classes.closedWrapper}`}
        >
          <Button
            className={classes.collapsedStopsStatus}
            color="primary"
            onClick={this.toggleExpand}
          >
            {`${routeData.driverName}'s Stops (${completedVsTotalStopsFormatter(
              routeData
            )})`}
            <ExpandLess className={classes.expandIcon} />
          </Button>
        </Paper>
      );
    }

    const isResequenceDisabled = !stopsWithoutDelays.length;
    const buttonColor = isStopListUpdated ? "primary" : null;
    const lowPriorityClass = this.state.resequencingInProgress
      ? classes.activeHeaderIcon
      : "";
    const hazmatPlacards =
      getRoutePlacards(routeData, this.props.DispatchStore.hazmatInfo ?? []) ??
      [];

    const lastConnectedTime =
      this.props.DispatchStore.driverLocations[routeData.driverId.toUpperCase()]?.lastConnectedTime ?? null;
    return (
      <Paper className={classes.outerMostWrapper}>
        <div className={classes.headerContainer}>
          <div className={classes.detailsContainer}>
            <IconButton onClick={this.toggleExpand}>
              <ArrowBack className={classes.backButtonSize} />
            </IconButton>
            <div>
              <div>
                <div>
                  <span className={classes.driverName}>
                    {routeData.driverName}
                  </span>
                </div>
                <div className={classes.driverStatusContainer}>
                  <span className={classes.driverPhoneNo}>
                    {`Phone # ${
                      routeData.driverPhoneNumber
                        ? routeData.driverPhoneNumber
                        : "N/A"
                    }`}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.detailsContainer}>
            <div className={classes.driverNumber}>
              {`# ${routeData.driverNumber}`}
            </div>
            {this.enableDispatchRouteResequence && (
              <div
                className={`${classes.stopIconStyles} ${
                  !isResequenceDisabled
                    ? classes.enableActiveIcon
                    : classes.disableIcon
                }`}
                onClick={
                  !isResequenceDisabled ? this.enableResequencing : null
                }
              >
                <StyledToolTip title="Resequence stops">
                  <div className="stop-list-icon-wrapper">
                    <LowPriority
                      className={`${classes.headerIcon} ${lowPriorityClass}`}
                    />
                  </div>
                </StyledToolTip>
              </div>
            )}
            <div
              className={`${classes.stopIconStyles} ${
                this.enableDropHookMove
                  ? classes.enableActiveIcon
                  : classes.disableIcon
              }`}
              onClick={
                this.enableDropHookMove ? this.handleDropAndHookMenuOpen : null
              }
            >
              <StyledToolTip
                title={
                  this.enableDropHookMove
                    ? "Drop-Hook-Move"
                    : "Drop-Hook-Move (Disabled)"
                }
              >
                <div className="stop-list-icon-wrapper">
                  <LocalShippingOutlinedIcon
                    className={classes.headerIcon}
                    color={
                      this.enableDropHookMove
                        ? theme.palette.primary.main
                        : theme.iconColor
                    }
                  />
                </div>
              </StyledToolTip>
            </div>
            {routeData.routeId ? (
              <div
                className={`${classes.stopIconStyles} ${
                  this.enableAddPro
                    ? classes.enableActiveIcon
                    : classes.disableIcon
                }`}
                onClick={this.enableAddPro ? this.handleAddPro : null}
              >
                <StyledToolTip
                  title={this.enableAddPro ? "Add pro" : "Add pro (Disabled)"}
                >
                  <div className="stop-list-icon-wrapper">
                    <AddBoxOutlined
                      className={
                        this.enableAddPro
                          ? classes.activeHeaderIcon
                          : classes.headerIcon
                      }
                    />
                  </div>
                </StyledToolTip>
              </div>
            ) : null}
            <IconButton aria-label="close" onClick={this.toggleExpand}>
              <Close className={classes.headerIcon} />
            </IconButton>
          </div>
        </div>
        {lastConnectedTime && (
          <RefreshWarningBar
            onRefreshClick={this.refreshStopList}
            lastRefreshTime={lastConnectedTime}
            terminalOffset={this.props.DispatchStore.terminalOffset}
          ></RefreshWarningBar>
        )}

        <div className={classes.contentContainer}>
          {!resequencingInProgress && (
            <div
              className={`${classes.lowerDetails} customScroll`}
              style={{
                minHeight: this.getRouteInfoMinHeight(
                  this.state.currentDriverRoutes.length,
                  hazmatPlacards.length
                ),
              }}
            >
              <Details
                routeData={routeData}
                latestLunchBreak={latestLunchBreak}
                currentDriverRoutes={this.state.currentDriverRoutes}
                changeRouteData={this.changeRouteData}
              />
              {hazmatPlacards.length ? (
                <HazmatPlacards placards={hazmatPlacards} />
              ) : null}
            </div>
          )}

          {resequencingInProgress && showResequenceHelperText && (
            <ResequenceHelperText close={this.hideResequenceHelperText} />
          )}

          <div
            ref={this.cardContainerRef}
            className={`${classes.cardsContainer} customScroll`}
          >
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="stopList">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {stopsWithoutDelays.map((stop, index) => (
                      <Draggable
                        key={stop.stopId}
                        draggableId={stop.stopId}
                        index={index}
                        isDragDisabled={this.isDragDisabled(stop)}
                      >
                        {(provided, snapshot) =>
                          this.getDraggableItem(provided, snapshot, stop)
                        }
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            <TerminalCard userData={this.props.userData} routeData={this.props.routeData}/>
          </div>
        </div>
        <div id="footer" className={classes.footer}>
          {resequencingInProgress ? (
            <div className={classes.footerAction}>
              <Button
                onClick={this.cancelResequence}
                variant="outlined"
                classes={{
                  root: `${classes.actionButton} ${classes.cancelButton}`,
                  text: classes.actionButtonText,
                  disabled: classes.cancelButtonDisabled,
                }}
              >
                Cancel
              </Button>
              <div className={classes.footerSpace} />
              <Button
                onClick={this.showConfirmationModal}
                variant="contained"
                color={buttonColor}
                classes={{
                  root: `${classes.actionButton} ${classes.saveButton}`,
                  text: classes.actionButtonText,
                }}
                size="medium"
                disabled={!isStopListUpdated}
              >
                Save Changes
              </Button>
            </div>
          ) : (
            `${footerDetails}`
          )}
        </div>

        {showPendingChangesWarning && (
          <Dialog
            title="Pending stop move changes"
            discardLabel="Discard"
            confirmLabel="Save changes"
            onClose={this.onClosePendingChangesWarning}
          >
            <div className={classes.dialogContent}>
              <div>There are pending stop move changes.</div>
              <div>
                Only sequence of stops which are locked will be retained on
                save.
              </div>
            </div>
          </Dialog>
        )}

        {showConfirmation && (
          <Dialog
            title="Confirm stop move"
            discardLabel="Cancel"
            confirmLabel="Save changes"
            onClose={this.onCloseConfirmation}
            contentProps
          >
            <div className={classes.dialogContent}>
              Only sequence of stops which are locked will be retained on save.
            </div>
          </Dialog>
        )}
        {this.state.isOpenDropHookMoveModal && <DropHookMoveModal
          open={this.state.isOpenDropHookMoveModal}
          routeData={routeData}
          currentDriverRoutes={this.state.currentDriverRoutes}
          handleClose={this.closeDropHookMoveModal}
        />}
        {this.state.isAddProInProgress && (
          <AddProDialog
            open={this.state.isAddProInProgress}
            handleClose={this.cancelAddPro}
            routeData={this.state.routeData}
          />
        )}

        {
          this.state.viewStopImages ? (
            <StopImagesDialog 
              showImages={this.state.viewStopImages.proNumbers?.[0] || Object.keys(STOP_IMAGES)[0]}
              {...this.state.viewStopImages}
              stops= {routeData.stops}
              close={this.onHideStopImages}
            />
          ) : null
        }
      </Paper>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withFeatureFlags,
  withSnackbar,
  withUserProfile,
  withAppConfig,
)(DriverPopup);
